<template>
  <div
    class="sheet-backdrop"
    :class="{ visible: visible }"
    v-show="wrapperVisible"
    @click.self="close"
  >
    <transition name="slide-up">
      <div v-if="visible" class="container sheet-container">
        <div class="row">
          <div class="col-12">
            <div class="sheet-container__title">
              <slot name="title" />
            </div>
            <div class="sheet-container__wrapper" ref="sheetWrapper">
              <slot name="content" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "AppBaseSheet",
  setup(_, { expose }) {
    const visible = ref(false);
    const wrapperVisible = ref(false);
    const sheetWrapper = ref(null);

    watch(visible, (visibleValue) => {
      if (visibleValue) {
        wrapperVisible.value = true;
      } else {
        setTimeout(() => {
          wrapperVisible.value = false;
        }, 350);
      }
    });

    const open = () => {
      visible.value = true;
    };

    const close = () => {
      visible.value = false;
    };

    expose({ open, close, sheetWrapper });

    return {
      visible,
      wrapperVisible,
      sheetWrapper,
      close,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.sheet-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-end;
  z-index: 999;
  opacity: 0;
  transition: opacity 0.35s ease;

  &.visible {
    opacity: 1;
  }

  .sheet-container {
    width: 100%;
    max-height: 100vh;
    padding: 30px 1rem;
    background: #18222b;
    border-radius: 25px 25px 0 0;

    &__title {
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: @white;
      margin-bottom: 30px;
      text-align: center;
    }

    &__wrapper {
      max-height: calc(100vh - 60px);
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.35s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
